import { Rid } from "./data/restaurant";

export enum Type {
  Veg = "veg",
  NonVeg = "non veg",
}

export enum Label {
  Chicken = "Chicken",
  Beef = "Beef",
  Prawns = "Prawns",
  Mutton = "Mutton",
  Dessert = "Dessert",
  Starter = "Starter",
  Fish = "Fish",
}

export type FoodItem = {
  id: string;
  name: string;
  description?: string;
  image: string;
  type: Type;
  restaurantId: Rid;
  labels: Array<Label | string>;
};

export type Restaurant = {
  name?: string;
  id: Rid;
  location: {
    place: string;
    url?: string;
  };
  website?: string;
  image?: string;
};
